import { User, Credential, Achievement, Endorsement } from '../types';

export const mockUsers: User[] = [
  {
    id: '1',
    address: '0x742d35Cc6634C0532925a3b8D1D8E9C7b5F6E123',
    name: 'Alex Chen',
    bio: 'Full-stack developer passionate about blockchain technology and decentralized applications. Always learning and contributing to open source.',
    avatar: 'https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&dpr=1&fit=crop&crop=face',
    skills: ['React', 'Solidity', 'Node.js', 'TypeScript', 'Web3'],
    location: 'San Francisco, CA',
    joinedDate: '2023-01-15',
    totalCredentials: 12,
    endorsements: 48,
    reputation: 875,
  },
  {
    id: '2',
    address: '0x1234567890abcdef1234567890abcdef12345678',
    name: 'Michael Johnson',
    bio: 'UX Designer with 5+ years experience. Focused on creating inclusive and accessible digital experiences.',
    avatar: 'https://images.pexels.com/photos/3785077/pexels-photo-3785077.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&dpr=1&fit=crop&crop=face',
    skills: ['UI/UX Design', 'Figma', 'User Research', 'Accessibility', 'Design Systems'],
    location: 'New York, NY',
    joinedDate: '2023-02-20',
    totalCredentials: 8,
    endorsements: 32,
    reputation: 645,
  },
  {
    id: '3',
    address: '0xabcdef1234567890abcdef1234567890abcdef12',
    name: 'Marcus Williams',
    bio: 'Blockchain educator and community builder. Teaching the next generation of Web3 developers.',
    avatar: 'https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&dpr=1&fit=crop&crop=face',
    skills: ['Education', 'Smart Contracts', 'Community Building', 'Technical Writing'],
    location: 'Austin, TX',
    joinedDate: '2022-11-10',
    totalCredentials: 15,
    endorsements: 67,
    reputation: 1250,
  },
];

export const mockCredentials: Credential[] = [
  {
    id: '1',
    title: 'Advanced React Development',
    category: 'Programming',
    description: 'Completed comprehensive React course covering hooks, context, performance optimization, and advanced patterns. Built 3 production-ready applications.',
    skills: ['React', 'JavaScript', 'TypeScript', 'Performance Optimization'],
    evidence: ['GitHub Repository', 'Live Demo', 'Code Review'],
    impactMetrics: {
      learningHours: 120,
      projectsCompleted: 3,
      peersHelped: 15,
      communityContributions: 8,
    },
    dateEarned: '2024-01-15',
    issuer: 'React Academy',
    verified: true,
    endorsements: 12,
    imageUrl: 'https://images.pexels.com/photos/11035380/pexels-photo-11035380.jpeg?auto=compress&cs=tinysrgb&w=600&h=400',
  },
  {
    id: '2',
    title: 'Smart Contract Security Audit',
    category: 'Blockchain',
    description: 'Successfully completed security audit of DeFi protocol, identifying and helping resolve 5 critical vulnerabilities.',
    skills: ['Solidity', 'Security Auditing', 'DeFi', 'Smart Contracts'],
    evidence: ['Audit Report', 'Vulnerability Assessment', 'Fix Verification'],
    impactMetrics: {
      learningHours: 80,
      projectsCompleted: 1,
      peersHelped: 25,
      communityContributions: 12,
    },
    dateEarned: '2024-02-20',
    issuer: 'CyberSec Institute',
    verified: true,
    endorsements: 18,
    imageUrl: 'https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?auto=compress&cs=tinysrgb&w=600&h=400',
  },
  {
    id: '3',
    title: 'Community Leadership Excellence',
    category: 'Leadership',
    description: 'Led successful community initiative that onboarded 200+ new developers to Web3. Organized workshops and mentorship programs.',
    skills: ['Leadership', 'Community Building', 'Mentorship', 'Event Organization'],
    evidence: ['Event Photos', 'Participant Testimonials', 'Impact Report'],
    impactMetrics: {
      learningHours: 60,
      projectsCompleted: 5,
      peersHelped: 200,
      communityContributions: 25,
    },
    dateEarned: '2024-01-30',
    issuer: 'Web3 Community Hub',
    verified: true,
    endorsements: 24,
    imageUrl: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=600&h=400',
  },
];

export const mockEndorsements: Endorsement[] = [
  {
    id: '1',
    endorserId: '2',
    credentialId: '1',
    endorser: mockUsers[1],
    message: 'Alex is an exceptional React developer. Their work on the community project was outstanding!',
    timestamp: '2024-01-20T10:30:00Z',
  },
  {
    id: '2',
    endorserId: '3',
    credentialId: '1',
    endorser: mockUsers[2],
    message: 'Highly skilled developer with great attention to detail and excellent problem-solving abilities.',
    timestamp: '2024-01-22T14:15:00Z',
  },
];

export const mockAchievements: Achievement[] = [
  {
    id: '1',
    userId: '1',
    credentialId: '1',
    user: mockUsers[0],
    credential: mockCredentials[0],
    timestamp: '2024-01-15T09:00:00Z',
    endorsements: [mockEndorsements[0], mockEndorsements[1]],
  },
  {
    id: '2',
    userId: '1',
    credentialId: '2',
    user: mockUsers[0],
    credential: mockCredentials[1],
    timestamp: '2024-02-20T11:30:00Z',
    endorsements: [],
  },
  {
    id: '3',
    userId: '1',
    credentialId: '3',
    user: mockUsers[0],
    credential: mockCredentials[2],
    timestamp: '2024-01-30T16:45:00Z',
    endorsements: [],
  },
];